import { getNodeViewDecorators } from './../../../../ricos-common-plugins/viewer.js';
import type { NodeViewDecorator, ViewerPlugin } from './../../../../ricos-types/index.js';
import type { ViewerPluginOptions } from './../../../types.js';

import { BreakoutDecorator } from './breakoutDecorator.js';
import { Decorators as NodeViewDecorators } from './nodeViewDecorators.js';

export const getDecorators = (
  plugins?: (ViewerPlugin | ViewerPluginOptions)[]
): NodeViewDecorator<JSX.Element>[] => [...getNodeViewDecorators(plugins), BreakoutDecorator];

export default NodeViewDecorators;
